import { authenticatedApi } from '../../../shared/api/apiClientUtils';

export interface NotificationTypeDto {
  notificationType: string;
  description: string;
  requiredInput: 'pot' | 'allocation' | 'deduction' | 'none' | 'raw';
  category: string;
}

export interface TriggerTestNotificationResponse {
  notificationDefinitionIds: string[];
  message: string;
}

export interface TriggerTestNotificationRequest {
  notificationType: string;
  potId?: string;
  allocationId?: string;
  deductionId?: string;
  rawNotificationType?: string;
  rawData?: string;
  forceUniqueDedup?: boolean;
}

export interface EntityOptionDto {
  id: string;
  label: string;
  status: string;
}

export interface NotificationEntityOptionsResponse {
  pots: EntityOptionDto[];
  allocations: EntityOptionDto[];
  deductions: EntityOptionDto[];
}

export const getNotificationEntityOptions =
  async (): Promise<NotificationEntityOptionsResponse> => {
    const response =
      await authenticatedApi.get<NotificationEntityOptionsResponse>(
        '/api/dev/notifications/entity-options'
      );
    return response.data;
  };

export const getNotificationScenarios = async (): Promise<
  NotificationTypeDto[]
> => {
  const response = await authenticatedApi.get<NotificationTypeDto[]>(
    '/api/dev/notifications/scenarios'
  );
  return response.data;
};

export const triggerTestNotification = async (
  request: TriggerTestNotificationRequest
): Promise<TriggerTestNotificationResponse> => {
  const response = await authenticatedApi.post<TriggerTestNotificationResponse>(
    '/api/dev/notifications/trigger',
    request
  );
  return response.data;
};
